import React from 'react';
import { useStore } from '../../stores';
import { useTranslateFunction } from '../../helpers/useTranslationHook';

export const Copyright = () => {

  const { poi } = useStore();
  const { t } = useTranslateFunction('infolayer')

  const CopyrightStringPiece = ({ poi, prefix, field }) => {
    return poi.active.previewImage?.[field] ? (
        <a className="inline-block ml-1" href={poi.active.previewImage?.[`${field}Url`]}>
          {prefix} {poi.active.previewImage?.[field]}
        </a>
    ) : null;
  };
    
  return (
    <div className="text-[10px]">

      { poi?.active?.copyright?.source && (
        <small className="block mb-1">
          &copy; <a href={poi.active.copyright?.sourceUrl}>{`${poi.active.copyright?.source}`}</a>
        </small>
      )}

      {poi?.active?.previewImage?.title || poi?.active?.previewImage?.source ? (
        
        <small className="block">
         
          &copy; {t('image')} { poi.active.previewImage?.title ? poi.active.previewImage?.title : null }
            
          <CopyrightStringPiece poi={poi} prefix={t('by')} field={'author'} />
            
          <CopyrightStringPiece poi={poi} prefix={t('license')} field={'license'} />
            
          <CopyrightStringPiece poi={poi} field={'source'} />

        </small>
        
      ) : null }

    </div>
  );
  
};